// extracted by mini-css-extract-plugin
export default {"grid":"GallerySection_grid__ACi9E","cell":"GallerySection_cell__Ny42U","imageRoot":"GallerySection_imageRoot__FtNzm","image":"GallerySection_image__8DaEs"};